d
<template>
  <component
    :is="isSupported ? 'button' : 'div'"
    type="button"
    :disabled="!isSupported || isLoading || forceLoading"
    class="flex items-center justify-center border border-l-0 rounded-sm rounded-l-none size-14 focus:outline-none"
    :class="{
      'border-terracota-dark': isFocused,
      'border-sienna-muted': !isFocused,
      'bg-beige': isFocused && !insideInputStyle,
    }"
    @click="handleClick"
  >
    <BaseLoadingIcon v-if="showLoading || forceLoading" class="size-5 top-7 right-4 -scale-x-1" />
    <LocationMarkerIcon
      v-else
      class="size-5 -scale-x-1"
      :class="{
        'text-terracota-dark': isFocused || insideInputStyle,
        'text-sienna-muted opacity-50': !isFocused && !insideInputStyle,
      }"
    />
  </component>
</template>

<script setup lang="ts">
  import useGeoLocation from '@/composables/useGeoLocation';
  import useSpinDelay from '@/composables/useSpinDelay';
  import { LocationMarkerIcon } from '@heroicons/vue/solid';

  interface Props {
    isFocused?: boolean;
    insideInputStyle?: boolean;
    forceLoading?: boolean;
  }

  interface Emits {
    (e: 'onPosition', position: GeolocationPosition['coords']): void;
  }

  defineProps<Props>();
  const emit = defineEmits<Emits>();

  const { isSupported, getPosition } = useGeoLocation();

  const isLoading = ref(false);
  const error = ref(null);

  const showLoading = useSpinDelay(isLoading);

  const handleClick = async () => {
    if (isSupported) {
      isLoading.value = true;
      try {
        const position = await getPosition();
        emit('onPosition', position);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        error.value = e;
      } finally {
        isLoading.value = false;
      }
    }
  };
</script>
